module.exports = __webpack_public_path__ + "static/img/she1.1e5f361.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardiobrain/she1.png
// module id = fUv+
// module chunks = 5